import { Link, useLocation } from "react-router-dom";
import { Box, Container, Grid, Typography, IconButton } from "@mui/material";
import { Phone,Email,LocationOn } from "@mui/icons-material";
import '../static/App.css';
import '../static/Footer.css';

const Footer = () => {
    const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
    const location = useLocation();

    const currentYear = new Date().getFullYear();

    return (
        <Box component="footer" className="footer">
            <Container maxWidth="lg">
                <Grid container spacing={4}>
                    {/* Company Info */}
                    <Grid item xs={12} md={4}>
                        <Typography variant="h6" gutterBottom className="footer-title">
                            24/7 Assure Care
                        </Typography>
                        <Typography variant="body2" className="footer-description">
                            Providing compassionate and reliable care services for your loved ones. 
                            We're committed to excellence in home care with trained professionals 
                            available around the clock.
                        </Typography>
                        
                        <Box className="footer-contact-info">
                            <Box className="contact-item">
                                <Phone fontSize="small" />
                                <Typography variant="body2" className="contact-text">
                                    <a href="tel:8474838999">847-483-8999</a>
                                </Typography>
                            </Box>
                            <Box className="contact-item">
                                <Email fontSize="small" />
                                <Typography variant="body2" className="contact-text">
                                    <a href="mailto:info@247assurecare.com">info@247assurecare.com</a>
                                </Typography>
                            </Box>
                            <Box className="contact-item">
                                <LocationOn fontSize="small" />
                                <Typography variant="body2" className="contact-text">
                                    Serving Illinois Communities
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>

                    {/* Resources */}
                    <Grid item xs={12} sm={6} md={4}>
                        <Typography variant="h6" gutterBottom className="footer-title">
                            Resources
                        </Typography>
                        <ul className='footer-list'>
                            <li><Link className='footer-link' to='/Resources' onClick={scrollToTop}>FAQ</Link></li>
                            <li><Link className='footer-link' to='/Contact' onClick={scrollToTop}>Contact Form</Link></li>
                            <li><Link className='footer-link' to='/Careers' onClick={scrollToTop}>Careers</Link></li>
                            <li><Link className='footer-link' to='/Privacy-policy' onClick={scrollToTop}>Privacy Policy</Link></li>
                            {/* <li><Link className='footer-link' to='/Terms-of-service' onClick={scrollToTop}>Terms of Service</Link></li> */}
                        </ul>
                    </Grid>

                    {/* About */}
                    <Grid item xs={12} sm={6} md={4}>
                        <Typography variant="h6" gutterBottom className="footer-title">
                            Quick Links
                        </Typography>
                        <ul className='footer-list'>
                            <li><Link className='footer-link' to='/AboutUs' onClick={scrollToTop}>About Us</Link></li>
                            <li><Link className='footer-link' to='/Services' onClick={scrollToTop}>Services</Link></li>
                            {/* <li><Link className='footer-link' to='/Testimonials' onClick={scrollToTop}>Testimonials</Link></li>
                            <li><Link className='footer-link' to='/Blog' onClick={scrollToTop}>Blog</Link></li> */}
                            <li><Link className='footer-link' to='/Contact' onClick={scrollToTop}>Get Started</Link></li>
                        </ul>
                    </Grid>
                </Grid>

                {/* Social Media & Copyright */}
                <Box className="footer-bottom">
                    
                    <Typography variant="body2" className="copyright">
                        &copy; {currentYear} 24/7 Assure Care LLC - All rights reserved.
                    </Typography>                    
                    {/* <Typography variant="caption" className="footer-note">
                        Licensed, Bonded, and Insured
                    </Typography> */}
                </Box>
            </Container>
        </Box>
    );
}

export default Footer;